module.exports = __webpack_public_path__ + "static/media/kinedu-educators-es.8a47c8dc.svg";